export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["से"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["को"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["राशि"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["स्थानांतरण"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["अपने खातों के बीच स्थानांतरण"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["वॉलेट के भीतर स्थानांतरण"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["प्रेषक और प्राप्तकर्ता के खाते अलग-अलग होने चाहिए"])}
}